<script lang="ts">
  import { SUBSCRIPTION_LIMITS } from '$lib/constants/subscription';
</script>

<div class="prompt-content">
  <div class="trial-expired-container">
    <div class="trial-expired-badge">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
      <span>체험 종료</span>
    </div>
    
    <h4 class="trial-expired-title">14일 무료 체험이 종료되었습니다</h4>
    <p class="trial-expired-subtitle">이제부터 무료 플랜이 적용됩니다</p>
  </div>
  
  <div class="plan-transition-info">
    <div class="transition-header">
      <span class="transition-label">무료 플랜에 포함된 기능</span>
    </div>
    <div class="feature-limits">
      <div class="limit-item">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>맞춤법 검사 하루 {SUBSCRIPTION_LIMITS.FREE.dailySpellCheckLimit}회</span>
      </div>
      <div class="limit-item">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>AI 분석 하루 {SUBSCRIPTION_LIMITS.FREE.dailyAIAnalysisLimit}회</span>
      </div>
      <div class="limit-item">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>최대 {SUBSCRIPTION_LIMITS.FREE.maxTextLength}자 텍스트</span>
      </div>
    </div>
  </div>
  
  <div class="premium-benefits">
    <div class="benefits-header">
      <span class="benefits-badge">프리미엄</span>
      <span class="benefits-title">모든 기능 무제한 이용</span>
    </div>
    <ul class="benefits-list">
      <li>
        <span class="benefit-icon">✓</span>
        <span>무제한 맞춤법 검사</span>
      </li>
      <li>
        <span class="benefit-icon">✓</span>
        <span>무제한 AI 분석</span>
      </li>
      <li>
        <span class="benefit-icon">✓</span>
        <span>최대 {SUBSCRIPTION_LIMITS.PREMIUM.maxTextLength.toLocaleString()}자 텍스트</span>
      </li>
      <li>
        <span class="benefit-icon">✓</span>
        <span>프리미엄 AI 모델 (GPT-4, Claude)</span>
      </li>
    </ul>
  </div>
</div>

<style>
  .trial-expired-container {
    text-align: center;
    margin-bottom: 20px;
  }

  .trial-expired-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: var(--bg-tertiary);
    border: 1px solid var(--border-primary);
    border-radius: 16px;
    margin-bottom: 12px;
  }

  .trial-expired-badge svg {
    width: 16px;
    height: 16px;
    color: var(--text-secondary);
  }

  .trial-expired-badge span {
    font-size: 11px;
    font-weight: 500;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .trial-expired-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 4px 0;
  }

  .trial-expired-subtitle {
    font-size: 14px;
    color: var(--text-secondary);
    margin: 0;
  }

  .plan-transition-info {
    background: var(--bg-secondary);
    border: 1px solid var(--border-primary);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
  }

  .transition-header {
    margin-bottom: 12px;
  }

  .transition-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .feature-limits {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .limit-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--text-primary);
    padding: 2px 0;
  }

  .limit-item svg {
    width: 16px;
    height: 16px;
    color: var(--text-tertiary);
    flex-shrink: 0;
  }

  .premium-benefits {
    border: 1px solid var(--accent-border);
    background: linear-gradient(to bottom, rgba(139, 92, 246, 0.02), rgba(99, 102, 241, 0.02));
    border-radius: 12px;
    padding: 16px;
  }

  .benefits-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  }

  .benefits-badge {
    display: inline-block;
    padding: 2px 8px;
    background: var(--accent-primary);
    color: white;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .benefits-title {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
  }

  .benefits-list {
    list-style: none;
    padding: 0;
    margin: 0 0 12px 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .benefits-list li {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--text-primary);
    padding: 2px 0;
  }

  .benefit-icon {
    color: var(--accent-primary);
    font-weight: 600;
    flex-shrink: 0;
  }
</style>